import React from 'react'
import PropTypes from 'prop-types'

class Headline extends React.Component {
  render() {
    const {importance} = this.props
    const {text, 'data-testid': dataTestId} = this.props
    let modifier = ''

    let headline

    switch (importance) {
      case 1:
        headline = <h1>{text}</h1>
        break
      case 2:
        headline = <h2>{text}</h2>
        break
      case 3:
        headline = <h3>{text}</h3>
        break
      case 4:
        headline = <h4>{text}</h4>
        break
      case 5:
        headline = <h5>{text}</h5>
        break
      case 6:
        headline = <h6>{text}</h6>
        break
      default:
        break
    }
    if (this.props.modifier) {
      modifier = ` headline--${this.props.modifier}`
    }

    return (
      <div data-testid={dataTestId} className={`headline${modifier}`}>
        {headline}
      </div>
    )
  }
}

Headline.propTypes = {
  importance: PropTypes.number,
  modifier: PropTypes.string,
  text: PropTypes.string,
  'data-testid': PropTypes.string,
}

export default Headline
